export default function FeaturedProducts() {
  const products = [
    {
      image: "/products/tshirt.png",
      title: "Custom T-Shirts",
      price: "From R150",
    },
    {
      image: "/products/hoodie.png",
      title: "Custom Hoodies",
      price: "From R350",
    },
    {
      image: "/products/cap.jpeg",
      title: "Caps",
      price: "From R180",
    },
    {
      image: "/products/sportswear.jpeg",
      title: "Sportswear",
      price: "From R220",
    },
    {
      image: "/products/mug.png",
      title: "Custom Mugs",
      price: "From R120",
    },
    {
      image: "/products/dtf.jpeg",
      title: "DTF Transfers",
      price: "Custom Quote",
    },
  ];

  return (
    <section className="bg-[#07101d] py-24 text-white">
      <div className="max-w-7xl mx-auto px-6">

        <h2 className="text-5xl font-black text-center mb-4">
          FEATURED PRODUCTS
        </h2>

        <p className="text-center text-gray-400 mb-16">
          Quality products printed with premium DTF technology.
        </p>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">

          {products.map((product) => (

            <div
              key={product.title}
              className="overflow-hidden rounded-3xl border border-sky-500/20 bg-slate-900 hover:-translate-y-2 transition duration-300 hover:shadow-2xl hover:shadow-sky-500/20"
            >

              <img
                src={product.image}
                alt={product.title}
                className="h-72 w-full object-cover"
              />

              <div className="p-8">

                <h3 className="text-2xl font-bold mb-2">
                  {product.title}
                </h3>

                <p className="text-sky-400 text-xl font-bold mb-6">
                  {product.price}
                </p>

                <a
                  href="https://wa.me/27660198386"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block rounded-xl bg-sky-500 py-4 text-center font-bold hover:bg-sky-400 transition"
                >
                  Order on WhatsApp
                </a>

              </div>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}